import { useMediaQuery } from "react-responsive";
import LogoVishwa from '@/assets/image/podcast/Icon-Vishwa.png'
import LogoSalesforce from '@/assets/image/podcast/Icon-Salesforce.png'
import LogoAxal from '@/assets/image/podcast/Icon-axal.png'
import LogoLSC from '@/assets/image/podcast/Icon-LSC.png'
import VishwaHead from '@/assets/image/podcast/vishwa_head.png'
import SalesforceHead from '@/assets/image/podcast/salesforce_head.png'
import LSCHead from '@/assets/image/podcast/LSC_head.png'
import AxalHead from '@/assets/image/podcast/axal_head.png'
import Guest1 from '@/assets/image/podcast/Guest1.png'
import Guest2 from '@/assets/image/podcast/Guest2.png'
import Guest3 from '@/assets/image/podcast/Guest3.png'
import Guest4 from '@/assets/image/podcast/Guest4.png'
import MainLogo from '@/assets/image/podcast/main_podcast.png'
import PostImg1 from '@/assets/image/podcast/PostImg1.png'
import PostImg2 from '@/assets/image/podcast/PostImg2.png'
import PostImg3 from '@/assets/image/podcast/PostImg3.png'
import PostImg4 from '@/assets/image/podcast/PostImg4.png'
import PostImg5 from '@/assets/image/podcast/PostImg5.png'
import PostImg6 from '@/assets/image/podcast/PostImg6.png'

import { Link } from 'react-router-dom';
import Nav from '@/components/LandingChrome/Nav'
import Footer from '@/components/LandingChrome/Footer'
import './index.scss'

// Dark backdrop so the microphone artwork (white mic on a black square, meant
// to sit on a dark page via plus-lighter) still reads on the cream theme.
const logoBackdrop = {  padding: '24px' }

const Podcast = () => {
  const isDesktop = useMediaQuery({ minWidth: 900 });
  const isLarge = useMediaQuery({ minWidth: 1340 });

  const guestList = [
    {
      castNo: 'Vishwa Hubble EP1',
      castContent: 'Wall Street x Web2 x Web3: Building Resilient System After the Crash',
      postUrl: PostImg1,
      casts: [
        LogoVishwa,
        LogoLSC,
        LogoAxal,
        LogoSalesforce
      ],
      desc: 'How do we build markets that don’t break? ',
      youtubeLink: 'https://youtu.be/RC6Obq56ht8',
      spotifyLink: 'https://open.spotify.com/episode/6uzNKcroxb8l5r1DfHAeiS?si=WmQxhjGCSKmB1Vj2kSs3rA',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Bo C.',
          cast: 'Lightswitch Capital',
        }, {
          img: AxalHead,
          name: 'Ashlan',
          cast: 'Axal',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    }, {
      castNo: 'Vishwa Hubble EP2',
      castContent: 'Agent-Native Banking: The Financial Infrastructure for Autonomous Capital',
      casts: [
        LogoVishwa,
        LogoAxal,
        LogoSalesforce
      ],
      desc: 'Autonomous capital needs more than payment rails. It needs mandates, permissions, risk controls, and infrastructure built for execution.',
      postUrl: PostImg2,
      youtubeLink: 'https://youtu.be/z95h9pTXfHA',
      spotifyLink: 'https://open.spotify.com/episode/6fl4jPXWhb8yr6T1a6rSzA?si=A7NQ5hrmSRmoN9U2cqLJqQ',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Bo C.',
          cast: 'Lightswitch Capital',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    }, {
      castNo: 'Vishwa Hubble EP3',
      castContent: 'Solana, x402, and the Future of Agent Payments',
      casts: [
        LogoVishwa,
        LogoAxal,
        LogoSalesforce
      ],
      postUrl: PostImg3,
      desc: 'Discuss how agent payments are evolving into agent-native banking-from x402 and payment flows to the controls institutions will require before autonomous systems can manage real capital. ',
      youtubeLink: 'https://youtu.be/B_9emYFTUo8',
      spotifyLink: 'https://open.spotify.com/episode/5ciTYzm5Baa5V6tuTqZn6q?si=8Mf0_ZEqSxWq-Vj9awBc2w',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Bo C.',
          cast: 'Lightswitch Capital',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    },
    {
      castNo: 'Vishwa Hubble EP4',
      castContent: 'Agent Passports: Identity Meets Control',
      postUrl: PostImg4,
      casts: [
        LogoVishwa,
        LogoAxal,
        LogoSalesforce
      ],
      youtubeLink: 'https://www.youtube.com/watch?v=-dmoyVaqjds&t=1154s',
      desc: 'Explore the infrastructure required for agents to operate safely across applications, services, and financial systems.',
      spotifyLink: 'https://open.spotify.com/episode/5VSJIOqemRLHAMzYg9Xhhl?si=0wfxtQgMRe2Ot0DvnQoadA',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Chi Zhang',
          cast: 'Co-Founder & CEO, KITE Al',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    },
    {
      castNo: 'Vishwa Hubble EP5',
      postUrl: PostImg5,
      castContent: 'AI Agents and the Future of Financial Infrastructure',
      casts: [
        LogoVishwa,
        LogoAxal,
        LogoSalesforce
      ],
      desc: 'Explores what financial institutions need before AI agents can move from giving advice to moving capital. ',
      youtubeLink: 'https://youtu.be/J2k2-LAxLWw',
      spotifyLink: 'https://open.spotify.com/episode/0Ju8kMKRJmTKTA83zsMTWf?si=BjAPEiTbRlyi7-JH-3-FPw',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Bo C.',
          cast: 'Lightswitch Capital',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    },
    {
      castNo: 'Vishwa Hubble EP6',
      postUrl: PostImg6,
      castContent: 'The Risk Architecture of Agentic Finance',
      casts: [
        LogoVishwa,
        LogoAxal,
        LogoSalesforce
      ],
      desc: 'Explore The Risk Architecture of Agentic Finance: From Digital Assets to Autonomous Capital.',
      youtubeLink: 'https://www.youtube.com/watch?v=K7-sjo_6sJM',
      spotifyLink: 'https://open.spotify.com/episode/5iOxe5QAVbsuzT1epSGww0?si=HL4emfcQRa6ShhcIr3xlGQ',
      logoHead: [
        {
          img: VishwaHead,
          name: 'Nathan Liang',
          cast: 'Vishwa',
        }, {
          img: LSCHead,
          name: 'Bo C.',
          cast: 'Lightswitch Capital',
        }, {
          img: SalesforceHead,
          name: 'Canice Wu',
          cast: 'Salesforce',
        }
      ]
    },
  ]

  return (
    <>
     <Nav home />
    <div className={`podcast ${isDesktop?`pt-[90px]`:`pt-[74px]`} text-[#16140F]`}>
     {
       isDesktop?(
         <div className={`bg-[#0A0B0D]`}>
           <div className={`w-1340 podcast-head flex items-center`}>
             <div className={`text-[#16140F] text-left flex-1 mr-[32px]`}>
               <div className={`podcast-title text-[64px] ${isDesktop ? `mb-[74px]` : `mb-[24px]`}`}>Podcast</div>
               <div className={`podcast-btn`}>
                 <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                   <div className={`podcast-btn_text`}>Get In Touch</div>
                 </Link>
                 <div className={`podcast-btn-mask`}/>
               </div>
             </div>
             <div className={`flex items-center`} style={logoBackdrop}>
               <img src={MainLogo} className={`h-[512px]`} style={{mixBlendMode: 'plus-lighter'}}/>
             </div>
           </div>
         </div>
       ) : (
         <div className={`podcast-head bg-[#0A0B0D] p-[40px_20px]`}>
           <div className={`flex items-center mb-[20px]`} style={logoBackdrop}>
             <img src={MainLogo} className={`w-[80%] ml-[10%]`} style={{mixBlendMode: 'plus-lighter'}}/>
           </div>
           <div className={`text-[#16140F] text-center flex-1 mr-[32px]`}>
             <div className={`podcast-title mb-[24px]`}>Podcast</div>
             <div className={`podcast-btn`} style={{margin: '0 auto'}}>
               <Link target="_blank" to="https://form.typeform.com/to/IjCOn4nY?typeform-source=vishwanetwork.xyz">
                 <div className={`podcast-btn_text`}>Get In Touch</div>
               </Link>
               <div className={`podcast-btn-mask`}/>
             </div>
           </div>
         </div>
       )
     }

     <div className={`${isDesktop ? `pt-[240px] pb-[240px]` : `pt-[80px] pb-[80px]`}`}>
       {
         isDesktop ? (
           <>
             {
               guestList.reverse().map((item, index) =>
                 <div key={index} className={`podcast-content-wrap mb-[40px]`}>
                   <div className={`w-1340 podcast-content flex`}>
                      <div className={`content-left ${isLarge ? 'w-[514px]' : 'w-1/2'} text-center`}>
                        <img src={item.postUrl} className={`w-full h-full`}/>
                      </div>
                     <div className={`content-right episode bg-[#fff] p-[32px_32px_24px]`}>
                       <div className={`text-[16px] episode-no mb-[32px]`}>{item?.castNo}</div>
                       <div className={`text-[28px] episode-desc mb-[12px]`}>
                         {item.castContent}
                       </div>
                       <div className={`text-[16px] episode-desc mb-[24px]`}>
                         {item?.desc}
                       </div>
                       <div className={`episode-desc text-[24px] flex gap-[12px] items-center`}>
                         <span className={`mr-[4px]`}>Watch on</span>
                         <Link target="_blank" className={`flex items-center gap-[8px]`}
                               to={item.youtubeLink}>
                           <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32"
                                fill="none">
                             <path
                               d="M12.5 19.9993L18.9875 15.9993L12.5 11.9993V19.9993ZM26.95 9.55935C27.1125 10.186 27.225 11.026 27.3 12.0927C27.3875 13.1593 27.425 14.0793 27.425 14.8793L27.5 15.9993C27.5 18.9193 27.3 21.066 26.95 22.4393C26.6375 23.6393 25.9125 24.4127 24.7875 24.746C24.2 24.9193 23.125 25.0394 21.475 25.1194C19.85 25.2127 18.3625 25.2527 16.9875 25.2527L15 25.3327C9.7625 25.3327 6.5 25.1193 5.2125 24.746C4.0875 24.4127 3.3625 23.6393 3.05 22.4393C2.8875 21.8127 2.775 20.9727 2.7 19.906C2.6125 18.8393 2.575 17.9193 2.575 17.1193L2.5 15.9993C2.5 13.0793 2.7 10.9327 3.05 9.55935C3.3625 8.35935 4.0875 7.58602 5.2125 7.25268C5.8 7.07935 6.875 6.95935 8.525 6.87935C10.15 6.78602 11.6375 6.74602 13.0125 6.74602L15 6.66602C20.2375 6.66602 23.5 6.87935 24.7875 7.25268C25.9125 7.58602 26.6375 8.35935 26.95 9.55935Z"
                               fill="#5A554C"/>
                           </svg>
                         </Link>
                         <span className={`opacity-[.5]`}>|</span>
                         <Link target="_blank" className={`episode-desc flex items-center gap-[8px]`}
                               to={item.spotifyLink}>
                           <svg role="img" viewBox="0 0 24 24" className="e-10451-logo" aria-label="Spotify"
                                aria-hidden="false" height="24" data-encore-id="logoSpotify"
                           >
                             <path
                               fill="#5A554C"
                               d="M13.427.01C6.805-.253 1.224 4.902.961 11.524.698 18.147 5.853 23.728 12.476 23.99c6.622.263 12.203-4.892 12.466-11.514S20.049.272 13.427.01m5.066 17.579a.717.717 0 0 1-.977.268 14.4 14.4 0 0 0-5.138-1.747 14.4 14.4 0 0 0-5.42.263.717.717 0 0 1-.338-1.392c1.95-.474 3.955-.571 5.958-.29 2.003.282 3.903.928 5.647 1.92a.717.717 0 0 1 .268.978m1.577-3.15a.93.93 0 0 1-1.262.376 17.7 17.7 0 0 0-5.972-1.96 17.7 17.7 0 0 0-6.281.238.93.93 0 0 1-1.11-.71.93.93 0 0 1 .71-1.11 19.5 19.5 0 0 1 6.94-.262 19.5 19.5 0 0 1 6.599 2.165c.452.245.62.81.376 1.263m1.748-3.551a1.147 1.147 0 0 1-1.546.488 21.4 21.4 0 0 0-6.918-2.208 21.4 21.4 0 0 0-7.259.215 1.146 1.146 0 0 1-.456-2.246 23.7 23.7 0 0 1 8.034-.24 23.7 23.7 0 0 1 7.657 2.445c.561.292.78.984.488 1.546m13.612-.036-.832-.247c-1.67-.495-2.14-.681-2.14-1.353 0-.637.708-1.327 2.264-1.327 1.539 0 2.839.752 3.51 1.31.116.096.24.052.24-.098V6.935c0-.097-.027-.15-.098-.203-.83-.62-2.272-1.07-3.723-1.07-2.953 0-4.722 1.68-4.722 3.59 0 2.157 1.371 2.91 3.626 3.546l.973.274c1.689.478 1.998.902 1.998 1.556 0 1.097-.831 1.433-2.07 1.433-1.556 0-3.457-.911-4.35-2.025-.08-.098-.177-.053-.177.062v2.423c0 .097.01.141.08.22.743.814 2.52 1.53 4.59 1.53 2.546 0 4.456-1.485 4.456-3.784 0-1.787-1.052-2.865-3.625-3.635m10.107-1.76c-1.68 0-2.653 1.026-3.219 2.052V9.376c0-.08-.044-.124-.124-.124h-2.22c-.079 0-.123.044-.123.124V20.72c0 .08.044.124.124.124h2.22c.079 0 .123-.044.123-.124v-4.536c.566 1.025 1.521 2.034 3.237 2.034 2.264 0 3.89-1.955 3.89-4.581s-1.644-4.545-3.908-4.545m-.654 6.986c-1.185 0-2.211-1.167-2.618-2.458.407-1.362 1.344-2.405 2.618-2.405 1.211 0 2.051.92 2.051 2.423s-.84 2.44-2.051 2.44m40.633-6.826h-2.264c-.08 0-.115.017-.15.097l-2.282 5.483-2.29-5.483c-.035-.08-.07-.097-.15-.097h-3.661v-.584c0-.955.645-1.397 1.476-1.397.496 0 1.035.256 1.415.486.089.053.15-.008.115-.088l-.796-1.901a.26.26 0 0 0-.124-.133c-.389-.203-1.025-.38-1.644-.38-1.875 0-2.954 1.432-2.954 3.254v.743h-1.503c-.08 0-.124.044-.124.124v1.768c0 .08.044.124.124.124h1.503v6.668c0 .08.044.123.124.123h2.264c.08 0 .124-.044.124-.123v-6.668h1.936l2.812 6.11-1.512 3.325c-.044.098.009.142.097.142h2.414c.08 0 .116-.018.15-.097l4.997-11.355c.035-.08-.009-.141-.097-.141M54.964 9.04c-2.865 0-4.837 2.025-4.837 4.616 0 2.573 1.971 4.616 4.837 4.616 2.856 0 4.846-2.043 4.846-4.616 0-2.591-1.99-4.616-4.846-4.616m.008 7.065c-1.37 0-2.343-1.043-2.343-2.45 0-1.405.973-2.449 2.343-2.449 1.362 0 2.335 1.043 2.335 2.45 0 1.406-.973 2.45-2.335 2.45m33.541-6.334a1.24 1.24 0 0 0-.483-.471 1.4 1.4 0 0 0-.693-.17q-.384 0-.693.17a1.24 1.24 0 0 0-.484.471q-.174.302-.174.681 0 .375.174.677.175.3.484.471t.693.17.693-.17.483-.471.175-.676q0-.38-.175-.682m-.211 1.247a1 1 0 0 1-.394.39 1.15 1.15 0 0 1-.571.14 1.16 1.16 0 0 1-.576-.14 1 1 0 0 1-.391-.39 1.14 1.14 0 0 1-.14-.566q0-.316.14-.562t.391-.388.576-.14q.32 0 .57.14.253.141.395.39t.142.565q0 .312-.142.56m-19.835-5.78c-.85 0-1.468.6-1.468 1.396s.619 1.397 1.468 1.397c.866 0 1.485-.6 1.485-1.397 0-.796-.619-1.397-1.485-1.397m19.329 5.19a.31.31 0 0 0 .134-.262q0-.168-.132-.266-.132-.099-.381-.099h-.588v1.229h.284v-.489h.154l.374.489h.35l-.41-.518a.5.5 0 0 0 .215-.084m-.424-.109h-.26v-.3h.27q.12 0 .184.036a.12.12 0 0 1 .065.116.12.12 0 0 1-.067.111.4.4 0 0 1-.192.037M69.607 9.252h-2.263c-.08 0-.124.044-.124.124v8.56c0 .08.044.123.124.123h2.263c.08 0 .124-.044.124-.123v-8.56c0-.08-.044-.124-.124-.124m-3.333 6.605a2.1 2.1 0 0 1-1.053.257c-.725 0-1.185-.425-1.185-1.362v-3.484h2.211c.08 0 .124-.044.124-.124V9.376c0-.08-.044-.124-.124-.124h-2.21V6.944c0-.097-.063-.15-.15-.08l-3.954 3.113c-.053.044-.07.088-.07.16v1.007c0 .08.044.124.123.124h1.539v3.855c0 2.087 1.203 3.06 2.918 3.06.743 0 1.46-.194 1.884-.442.062-.035.07-.07.07-.133v-1.68c0-.088-.044-.115-.123-.07"
                               transform="translate(-0.95,0)"></path>
                           </svg>
                         </Link>

                       </div>
                     </div>
                   </div>
                 </div>
               )
             }
           </>
         ) : (
           <>
           {
               guestList.reverse().map((item, index) =>
                 <div key={index} className={`podcast-content-wrap  mb-[0px]`}>
                   <div className={`mobile-podcast-content podcast-content`}>
                     <div className={`content-left text-center`}>
                       <img src={item.postUrl} className={`w-full h-full`}/>
                     </div>
                     <div className={`content-right episode bg-[#fff] p-[32px_20px_24px]`}>
                       <div className={`text-[14px] episode-no mb-[24px]`}>{item?.castNo}</div>
                       <div className={`text-[24px] episode-desc mb-[12px]`}>
                         {item.castContent}
                       </div>
                       <div className={`text-[24px] flex items-center episode-no mb-[24px] gap-[8px]`}>
                         <span className={`mr-[4px] episode-no`}>Watch on</span>
                         <Link target="_blank" className={`flex items-center gap-[8px]`}
                               to={item.youtubeLink}>
                           <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32"
                                fill="none">
                             <path
                               d="M12.5 19.9993L18.9875 15.9993L12.5 11.9993V19.9993ZM26.95 9.55935C27.1125 10.186 27.225 11.026 27.3 12.0927C27.3875 13.1593 27.425 14.0793 27.425 14.8793L27.5 15.9993C27.5 18.9193 27.3 21.066 26.95 22.4393C26.6375 23.6393 25.9125 24.4127 24.7875 24.746C24.2 24.9193 23.125 25.0394 21.475 25.1194C19.85 25.2127 18.3625 25.2527 16.9875 25.2527L15 25.3327C9.7625 25.3327 6.5 25.1193 5.2125 24.746C4.0875 24.4127 3.3625 23.6393 3.05 22.4393C2.8875 21.8127 2.775 20.9727 2.7 19.906C2.6125 18.8393 2.575 17.9193 2.575 17.1193L2.5 15.9993C2.5 13.0793 2.7 10.9327 3.05 9.55935C3.3625 8.35935 4.0875 7.58602 5.2125 7.25268C5.8 7.07935 6.875 6.95935 8.525 6.87935C10.15 6.78602 11.6375 6.74602 13.0125 6.74602L15 6.66602C20.2375 6.66602 23.5 6.87935 24.7875 7.25268C25.9125 7.58602 26.6375 8.35935 26.95 9.55935Z"
                               fill="#5A554C"/>
                           </svg>
                         </Link>
                         <span className={`opacity-[.5]`}>|</span>
                         <Link target="_blank" className={`episode-desc flex items-center gap-[8px]`}
                               to={item.spotifyLink}>
                           <svg role="img" viewBox="0 0 24 24" className="e-10451-logo" aria-label="Spotify"
                                aria-hidden="false" height="24" data-encore-id="logoSpotify"
                           >
                             <path
                               fill="#5A554C"
                               d="M13.427.01C6.805-.253 1.224 4.902.961 11.524.698 18.147 5.853 23.728 12.476 23.99c6.622.263 12.203-4.892 12.466-11.514S20.049.272 13.427.01m5.066 17.579a.717.717 0 0 1-.977.268 14.4 14.4 0 0 0-5.138-1.747 14.4 14.4 0 0 0-5.42.263.717.717 0 0 1-.338-1.392c1.95-.474 3.955-.571 5.958-.29 2.003.282 3.903.928 5.647 1.92a.717.717 0 0 1 .268.978m1.577-3.15a.93.93 0 0 1-1.262.376 17.7 17.7 0 0 0-5.972-1.96 17.7 17.7 0 0 0-6.281.238.93.93 0 0 1-1.11-.71.93.93 0 0 1 .71-1.11 19.5 19.5 0 0 1 6.94-.262 19.5 19.5 0 0 1 6.599 2.165c.452.245.62.81.376 1.263m1.748-3.551a1.147 1.147 0 0 1-1.546.488 21.4 21.4 0 0 0-6.918-2.208 21.4 21.4 0 0 0-7.259.215 1.146 1.146 0 0 1-.456-2.246 23.7 23.7 0 0 1 8.034-.24 23.7 23.7 0 0 1 7.657 2.445c.561.292.78.984.488 1.546m13.612-.036-.832-.247c-1.67-.495-2.14-.681-2.14-1.353 0-.637.708-1.327 2.264-1.327 1.539 0 2.839.752 3.51 1.31.116.096.24.052.24-.098V6.935c0-.097-.027-.15-.098-.203-.83-.62-2.272-1.07-3.723-1.07-2.953 0-4.722 1.68-4.722 3.59 0 2.157 1.371 2.91 3.626 3.546l.973.274c1.689.478 1.998.902 1.998 1.556 0 1.097-.831 1.433-2.07 1.433-1.556 0-3.457-.911-4.35-2.025-.08-.098-.177-.053-.177.062v2.423c0 .097.01.141.08.22.743.814 2.52 1.53 4.59 1.53 2.546 0 4.456-1.485 4.456-3.784 0-1.787-1.052-2.865-3.625-3.635m10.107-1.76c-1.68 0-2.653 1.026-3.219 2.052V9.376c0-.08-.044-.124-.124-.124h-2.22c-.079 0-.123.044-.123.124V20.72c0 .08.044.124.124.124h2.22c.079 0 .123-.044.123-.124v-4.536c.566 1.025 1.521 2.034 3.237 2.034 2.264 0 3.89-1.955 3.89-4.581s-1.644-4.545-3.908-4.545m-.654 6.986c-1.185 0-2.211-1.167-2.618-2.458.407-1.362 1.344-2.405 2.618-2.405 1.211 0 2.051.92 2.051 2.423s-.84 2.44-2.051 2.44m40.633-6.826h-2.264c-.08 0-.115.017-.15.097l-2.282 5.483-2.29-5.483c-.035-.08-.07-.097-.15-.097h-3.661v-.584c0-.955.645-1.397 1.476-1.397.496 0 1.035.256 1.415.486.089.053.15-.008.115-.088l-.796-1.901a.26.26 0 0 0-.124-.133c-.389-.203-1.025-.38-1.644-.38-1.875 0-2.954 1.432-2.954 3.254v.743h-1.503c-.08 0-.124.044-.124.124v1.768c0 .08.044.124.124.124h1.503v6.668c0 .08.044.123.124.123h2.264c.08 0 .124-.044.124-.123v-6.668h1.936l2.812 6.11-1.512 3.325c-.044.098.009.142.097.142h2.414c.08 0 .116-.018.15-.097l4.997-11.355c.035-.08-.009-.141-.097-.141M54.964 9.04c-2.865 0-4.837 2.025-4.837 4.616 0 2.573 1.971 4.616 4.837 4.616 2.856 0 4.846-2.043 4.846-4.616 0-2.591-1.99-4.616-4.846-4.616m.008 7.065c-1.37 0-2.343-1.043-2.343-2.45 0-1.405.973-2.449 2.343-2.449 1.362 0 2.335 1.043 2.335 2.45 0 1.406-.973 2.45-2.335 2.45m33.541-6.334a1.24 1.24 0 0 0-.483-.471 1.4 1.4 0 0 0-.693-.17q-.384 0-.693.17a1.24 1.24 0 0 0-.484.471q-.174.302-.174.681 0 .375.174.677.175.3.484.471t.693.17.693-.17.483-.471.175-.676q0-.38-.175-.682m-.211 1.247a1 1 0 0 1-.394.39 1.15 1.15 0 0 1-.571.14 1.16 1.16 0 0 1-.576-.14 1 1 0 0 1-.391-.39 1.14 1.14 0 0 1-.14-.566q0-.316.14-.562t.391-.388.576-.14q.32 0 .57.14.253.141.395.39t.142.565q0 .312-.142.56m-19.835-5.78c-.85 0-1.468.6-1.468 1.396s.619 1.397 1.468 1.397c.866 0 1.485-.6 1.485-1.397 0-.796-.619-1.397-1.485-1.397m19.329 5.19a.31.31 0 0 0 .134-.262q0-.168-.132-.266-.132-.099-.381-.099h-.588v1.229h.284v-.489h.154l.374.489h.35l-.41-.518a.5.5 0 0 0 .215-.084m-.424-.109h-.26v-.3h.27q.12 0 .184.036a.12.12 0 0 1 .065.116.12.12 0 0 1-.067.111.4.4 0 0 1-.192.037M69.607 9.252h-2.263c-.08 0-.124.044-.124.124v8.56c0 .08.044.123.124.123h2.263c.08 0 .124-.044.124-.123v-8.56c0-.08-.044-.124-.124-.124m-3.333 6.605a2.1 2.1 0 0 1-1.053.257c-.725 0-1.185-.425-1.185-1.362v-3.484h2.211c.08 0 .124-.044.124-.124V9.376c0-.08-.044-.124-.124-.124h-2.21V6.944c0-.097-.063-.15-.15-.08l-3.954 3.113c-.053.044-.07.088-.07.16v1.007c0 .08.044.124.123.124h1.539v3.855c0 2.087 1.203 3.06 2.918 3.06.743 0 1.46-.194 1.884-.442.062-.035.07-.07.07-.133v-1.68c0-.088-.044-.115-.123-.07"
                               transform="translate(-0.95,0)"></path>
                           </svg>
                         </Link>
                       </div>
                     </div>
                   </div>
                 </div>
               )
           }
           </>
         )
       }

     </div>

    </div>
     <Footer />
    </>
  )
}

export default Podcast
